export const darkMode = {
    colors: {
        backgroundColor: '#3a3335',
        white: '#ffffff',
        fireOpal: '#eb5e55',
        ruby: '#d81e5b',
        papayaWhip: '#fdf0d5',
        opal: '#c6d8d3',
    }
}

export const tectoniqMode = {
    colors: {
        backgroundColor: '#0b1220',
        white: '#e8f1ff',
        fireOpal: '#4fb3ff',
        ruby: '#39d0c3',
        papayaWhip: '#ffd166',
        opal: '#7f9cc0',
    }
}

export const themes = {
    dark: darkMode,
    tectoniq: tectoniqMode,
}
